/* Adorned Paws — theme.js
   Dependency-free. Restrained motion, respects prefers-reduced-motion.
   Modules: reveal · announcement · drawers · header · accordions · qty · strips · gallery · variants · cart · misc */
(function () {
  'use strict';

  var AP = window.AP || {};
  var routes = AP.routes || {};
  var strings = AP.strings || {};
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return rmq.matches; }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  /* ------------------------------------------------------------------ Reveal */
  var io = null, ioClip = null;
  function onEntries(observer) {
    return function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.intersectionRatio > 0) { e.target.classList.add('is-in'); observer.unobserve(e.target); }
      });
    };
  }
  function initReveal(root) {
    var els = $$('[data-reveal]', root || document).filter(function (el) { return !el.classList.contains('is-in'); });
    if (!els.length) return;
    if (document.body.classList.contains('reveal-off') || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) { onEntries(io)(entries); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      // Clip-path reveals: Chromium applies the target's own clip-path when measuring intersection,
      // so a fully clipped element never reaches an area threshold. Use threshold 0 + isIntersecting for those.
      ioClip = new IntersectionObserver(function (entries) { onEntries(ioClip)(entries); }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    }
    els.forEach(function (el) { (el.getAttribute('data-reveal') === 'clip' ? ioClip : io).observe(el); });
    // Anything already above the fold on a long page should never stay hidden.
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 900);
  }
  function initStagger(root) {
    $$('[data-reveal-stagger]', root || document).forEach(function (c) {
      var step = parseInt(c.getAttribute('data-reveal-stagger') || '90', 10);
      var kids = $$(':scope > [data-reveal]', c);
      kids.forEach(function (el, i) { el.style.setProperty('--reveal-delay', Math.min(i * step, 640) + 'ms'); });
    });
  }

  /* ------------------------------------------------------------ Announcement */
  function initAnnounce(root) {
    $$('[data-announce]', root || document).forEach(function (bar) {
      if (bar.__ap) return; bar.__ap = true;
      var items = $$('.ap-announce__item', bar);
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === 0); });
      if (items.length < 2) return;
      var i = 0, ms = parseInt(bar.getAttribute('data-interval') || '6000', 10);
      setInterval(function () {
        if (document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ----------------------------------------------------------------- Drawers */
  var drawer = { current: null, lastFocus: null };
  function overlay() { return $('[data-overlay]'); }
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return false;
    if (drawer.current && drawer.current !== d) closeDrawer(true);
    drawer.lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (overlay()) overlay().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.current = d;
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('[data-autofocus]', d) || $('button, a, input, select, textarea', d);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function closeDrawer(keepOverlay) {
    var d = drawer.current; if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    drawer.current = null;
    if (!keepOverlay) {
      if (overlay()) overlay().classList.remove('is-open');
      document.body.style.overflow = '';
      if (drawer.lastFocus && drawer.lastFocus.focus) drawer.lastFocus.focus({ preventScroll: true });
    }
  }
  function initDrawers() {
    on(document, 'click', function (e) {
      var o = e.target.closest('[data-drawer-open]');
      if (o) { if (openDrawer(o.getAttribute('data-drawer-open'))) e.preventDefault(); return; }
      var c = e.target.closest('[data-drawer-close]');
      if (c) { e.preventDefault(); closeDrawer(); return; }
      var cartOpen = e.target.closest('[data-cart-open]');
      if (cartOpen && AP.cartType === 'drawer' && $('[data-drawer="cart"]')) { e.preventDefault(); openDrawer('cart'); return; }
      if (e.target.matches('[data-overlay]')) closeDrawer();
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') {
        if (drawer.current) closeDrawer();
        var sb = $('[data-searchbar].is-open'); if (sb) toggleSearch(false);
        $$('.ap-nav > li.is-open').forEach(function (li) { li.classList.remove('is-open'); });
      }
      // Focus trap inside open drawer
      if (e.key === 'Tab' && drawer.current) {
        var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', drawer.current)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // Mobile menu sub-toggles
    on(document, 'click', function (e) {
      var t = e.target.closest('[data-menu-toggle]');
      if (!t) return;
      e.preventDefault();
      var sub = document.getElementById(t.getAttribute('aria-controls'));
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sub) sub.classList.toggle('is-open', !open);
    });
  }

  /* ------------------------------------------------------------------ Header */
  function toggleSearch(force) {
    var bar = $('[data-searchbar]'); if (!bar) return;
    var open = typeof force === 'boolean' ? force : !bar.classList.contains('is-open');
    bar.classList.toggle('is-open', open);
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var inp = $('[data-search-input]', bar); if (inp) setTimeout(function () { inp.focus(); }, 120); }
  }
  function initHeader() {
    on(document, 'click', function (e) {
      var t = e.target.closest('[data-search-toggle]');
      if (t) { e.preventDefault(); toggleSearch(); return; }
      // Touch: first tap on a parent nav link opens the submenu, second follows it.
      var p = e.target.closest('[data-nav-parent]');
      if (p && window.matchMedia('(hover: none)').matches) {
        var li = p.parentElement;
        if (!li.classList.contains('is-open')) { e.preventDefault(); $$('.ap-nav > li.is-open').forEach(function (o) { o.classList.remove('is-open'); }); li.classList.add('is-open'); p.setAttribute('aria-expanded', 'true'); }
      } else if (!e.target.closest('.ap-nav')) {
        $$('.ap-nav > li.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });
    // Sticky offset for the sticky buy box
    var h = $('[data-header]');
    function setOffset() {
      var sticky = h && h.classList.contains('ap-header--sticky');
      document.documentElement.style.setProperty('--sticky-offset', sticky ? h.offsetHeight + 'px' : '0px');
    }
    setOffset(); on(window, 'resize', setOffset);
  }

  /* -------------------------------------------------------------- Accordions */
  function setItem(item, open) {
    item.classList.toggle('is-open', open);
    var btn = $('.ap-acc__btn', item); if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var inner = $('.ap-acc__inner', item);
    if (inner) { if (open) inner.removeAttribute('inert'); else inner.setAttribute('inert', ''); }
  }
  function initAccordions(root) {
    $$('[data-accordion]', root || document).forEach(function (group) {
      if (group.__ap) return; group.__ap = true;
      var single = group.getAttribute('data-accordion') !== 'multi';
      $$('.ap-acc__item', group).forEach(function (item) { setItem(item, item.classList.contains('is-open')); });
      on(group, 'click', function (e) {
        var btn = e.target.closest('.ap-acc__btn'); if (!btn || !group.contains(btn)) return;
        var item = btn.closest('.ap-acc__item');
        var open = item.classList.contains('is-open');
        if (single) $$('.ap-acc__item.is-open', group).forEach(function (o) { if (o !== item) setItem(o, false); });
        setItem(item, !open);
      });
    });
  }

  /* -------------------------------------------------------------------- Qty */
  function initQty() {
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-qty-minus],[data-qty-plus]'); if (!b) return;
      e.preventDefault();
      var wrap = b.closest('[data-qty]'); var inp = $('input', wrap); if (!inp) return;
      var v = parseInt(inp.value || '1', 10) || 1;
      var min = parseInt(inp.getAttribute('min') || '1', 10);
      v = b.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
      inp.value = v;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ----------------------------------------------------------------- Strips */
  function initStrips(root) {
    $$('[data-strip]', root || document).forEach(function (strip) {
      if (strip.__ap) return; strip.__ap = true;
      var track = $('[data-strip-track]', strip); if (!track) return;
      var speed = parseFloat(strip.getAttribute('data-speed') || '0.5');
      var step = parseInt(strip.getAttribute('data-step') || '320', 10);
      var autoplay = strip.getAttribute('data-autoplay') !== 'false' && !reduced();
      var paused = false, hold = null;
      function half() { return track.scrollWidth / 2; }
      function pause(ms) { paused = true; clearTimeout(hold); if (ms) hold = setTimeout(function () { paused = false; }, ms); }
      if (autoplay) {
        var vis = new IntersectionObserver(function (en) { strip.__visible = en[0].isIntersecting; }, { threshold: 0 });
        vis.observe(strip);
        on(track, 'mouseenter', function () { pause(); });
        on(track, 'mouseleave', function () { paused = false; });
        on(track, 'focusin', function () { pause(); });
        on(track, 'focusout', function () { paused = false; });
        on(track, 'touchstart', function () { pause(); }, { passive: true });
        on(track, 'touchend', function () { pause(2200); }, { passive: true });
        on(track, 'wheel', function () { pause(2200); }, { passive: true });
        (function tick() {
          if (!paused && !document.hidden && strip.__visible !== false) {
            if (track.scrollLeft >= half()) track.scrollLeft -= half();
            else track.scrollLeft += speed;
          }
          requestAnimationFrame(tick);
        })();
      }
      on($('[data-strip-prev]', strip), 'click', function () { pause(1400); track.scrollBy({ left: -step, behavior: reduced() ? 'auto' : 'smooth' }); });
      on($('[data-strip-next]', strip), 'click', function () { pause(1400); track.scrollBy({ left: step, behavior: reduced() ? 'auto' : 'smooth' }); });
    });
  }

  /* ---------------------------------------------------------------- Gallery */
  function initGallery(root) {
    $$('[data-gallery]', root || document).forEach(function (g) {
      if (g.__ap) return; g.__ap = true;
      var main = $('[data-gallery-main]', g); if (!main) return;
      on(g, 'click', function (e) {
        var t = e.target.closest('[data-gallery-thumb]'); if (!t) return;
        e.preventDefault();
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        var src = t.getAttribute('data-src'), srcset = t.getAttribute('data-srcset') || '', alt = t.getAttribute('data-alt') || '';
        var pre = new Image(); if (srcset) pre.srcset = srcset; pre.src = src;
        var swap = function () {
          if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
          main.src = src; main.alt = alt;
          requestAnimationFrame(function () { main.classList.remove('is-fading'); });
        };
        if (reduced()) { swap(); return; }
        main.classList.add('is-fading');
        var done = false; var go = function () { if (done) return; done = true; swap(); };
        pre.onload = function () { setTimeout(go, 200); }; pre.onerror = go; setTimeout(go, 900);
      });
    });
  }

  /* ------------------------------------------------------------------- Hero */
  function initHero() {
    $$('.ap-hero').forEach(function (h) {
      var img = $('img', h);
      var mark = function () { h.classList.add('is-loaded'); };
      if (!img || img.complete) requestAnimationFrame(function () { requestAnimationFrame(mark); });
      else { on(img, 'load', mark); setTimeout(mark, 1200); }
    });
  }

  /* --------------------------------------------------------------- Variants */
  function money(cents) {
    var fmt = AP.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }
  function initVariants(root) {
    $$('[data-product-form]', root || document).forEach(function (form) {
      if (form.__apv) return; form.__apv = true;
      var dataEl = $('[data-variants]', form.closest('[data-product]') || document);
      if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = $$('[data-option-select]', form);
      if (!selects.length) return;
      var idInput = $('[name="id"]', form);
      var btn = $('[data-add-button]', form);
      var priceEl = $('[data-price]', form.closest('[data-product]') || document);
      var compareEl = $('[data-compare-price]', form.closest('[data-product]') || document);
      function update() {
        var opts = selects.map(function (s) { return s.value; });
        var v = variants.filter(function (x) { return opts.every(function (o, i) { return x.options[i] === o; }); })[0];
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = strings.unavailable || 'Unavailable'; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (strings.addToBag || 'Add to bag') : (strings.soldOut || 'Sold out'); }
        if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      }
      selects.forEach(function (s) { on(s, 'change', update); });
    });
  }

  /* ------------------------------------------------------------------- Cart */
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) { t = document.createElement('div'); t.className = 'ap-toast'; t.setAttribute('data-toast', ''); t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = count; });
  }
  function replaceFromHTML(html, selector, targetSel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $(selector, doc); var target = $(targetSel || selector);
    if (fresh && target) { target.innerHTML = fresh.innerHTML; return target; }
    return null;
  }
  function sectionIds() {
    var ids = [];
    if ($('[data-drawer="cart"]')) ids.push('cart-drawer');
    var page = $('[data-cart-page]'); if (page && page.getAttribute('data-section-id')) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) replaceFromHTML(sections['cart-drawer'], '[data-cart-drawer-content]');
    var page = $('[data-cart-page]');
    if (page) { var id = page.getAttribute('data-section-id'); if (sections[id]) replaceFromHTML(sections[id], '[data-cart-page]'); }
    var lbl = $('[data-cart-count-label]');
    if (lbl) updateCounts(lbl.textContent.trim());
    initAccordions(); initReveal(); initGiftNote();
  }
  function cartRequest(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refreshCart() {
    return fetch((routes.cart_url || '/cart') + '?sections=' + sectionIds().join(','), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(applySections).catch(function () {});
  }
  function initCart() {
    // Add to bag
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[data-ajax-add]'); if (!form) return;
      e.preventDefault();
      var btn = $('[data-add-button]', form); var label = btn ? btn.textContent : '';
      if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
      var fd = new FormData(form);
      var body = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }], sections: sectionIds().join(','), sections_url: window.location.pathname };
      cartRequest((routes.cart_add_url || '/cart/add') + '.js', body).then(function (res) {
        applySections(res.sections);
        if (btn) { btn.textContent = strings.added || 'Added to bag'; setTimeout(function () { btn.textContent = label; }, 1800); }
        if (AP.cartType === 'drawer' && $('[data-drawer="cart"]')) openDrawer('cart'); else toast(strings.added || 'Added to bag');
        if (!res.sections) refreshCart();
      }).catch(function (err) {
        toast((err && (err.description || err.message)) || strings.error || 'Something did not go through. Try once more.');
      }).then(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); } });
    });
    // Line changes
    on(document, 'change', function (e) {
      var inp = e.target.closest('[data-cart-line] input[data-line-qty]'); if (!inp) return;
      var line = parseInt(inp.closest('[data-cart-line]').getAttribute('data-line'), 10);
      changeLine(line, parseInt(inp.value, 10) || 0);
    });
    on(document, 'click', function (e) {
      var r = e.target.closest('[data-line-remove]'); if (!r) return;
      e.preventDefault();
      changeLine(parseInt(r.closest('[data-cart-line]').getAttribute('data-line'), 10), 0);
    });
    function changeLine(line, qty) {
      var row = $('[data-cart-line][data-line="' + line + '"]'); if (row) row.style.opacity = '.5';
      cartRequest((routes.cart_change_url || '/cart/change') + '.js', { line: line, quantity: qty, sections: sectionIds().join(','), sections_url: window.location.pathname })
        .then(function (res) { applySections(res.sections); })
        .catch(function () { refreshCart(); });
    }
    // Cart note (gift note)
    var noteTimer;
    on(document, 'input', function (e) {
      var ta = e.target.closest('[data-cart-note]'); if (!ta) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch((routes.cart_update_url || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: ta.value }) }).catch(function () {});
      }, 500);
    });
  }
  function initGiftNote() {
    $$('[data-giftnote-toggle]').forEach(function (t) {
      if (t.__ap) return; t.__ap = true;
      on(t, 'click', function (e) {
        e.preventDefault();
        var p = document.getElementById(t.getAttribute('aria-controls')); var open = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', open ? 'false' : 'true'); if (p) { p.classList.toggle('is-open', !open); if (!open) { var ta = $('textarea', p); if (ta) setTimeout(function () { ta.focus(); }, 300); } }
      });
    });
  }

  /* --------------------------------------------------------------- Waitlist */
  function initWaitlist() {
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-waitlist-toggle],[data-toggle]'); if (!b) return;
      e.preventDefault();
      var f = document.getElementById(b.getAttribute('aria-controls')); if (!f) return;
      f.hidden = !f.hidden; b.setAttribute('aria-expanded', f.hidden ? 'false' : 'true');
      var hideSel = b.getAttribute('data-toggle-hide'); if (hideSel) { var h = $(hideSel); if (h) h.hidden = !f.hidden; }
      if (!f.hidden) { var i = $('input[type="email"], input[type="password"], input', f); if (i) i.focus(); }
    });
  }

  /* ------------------------------------------------------------------ Init */
  function initAll(root) {
    initStagger(root); initReveal(root); initAnnounce(root); initAccordions(root); initStrips(root); initGallery(root); initVariants(root); initGiftNote();
  }
  function boot() {
    if (AP.reveal === false) document.body.classList.add('reveal-off');
    initDrawers(); initHeader(); initQty(); initCart(); initWaitlist(); initHero();
    if (window.location.hash === '#recover') { var rb = $('[data-toggle][aria-controls="RecoverForm"]'); if (rb) rb.click(); }
    initAll(document);
    // Theme editor support
    on(document, 'shopify:section:load', function (e) { initAll(e.target); initHero(); });
    on(document, 'shopify:section:select', function (e) { var d = e.target.querySelector('[data-drawer]'); if (d) openDrawer(d.getAttribute('data-drawer')); });
    on(document, 'shopify:section:deselect', function () { closeDrawer(); });
    on(document, 'shopify:block:select', function (e) {
      var item = e.target.closest('.ap-acc__item'); if (item) { var g = item.closest('[data-accordion]'); $$('.ap-acc__item.is-open', g).forEach(function (o) { setItem(o, false); }); setItem(item, true); }
    });
  }
  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', boot); else boot();
})();
